import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=4d7d3afd&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7d3afd')) {
      api.createRecord('4d7d3afd', component.options)
    } else {
      api.reload('4d7d3afd', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=4d7d3afd&", function () {
      api.rerender('4d7d3afd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rhtuXsDzIjoA/JS/comp/ImgFallback.vue"
export default component.exports